module.exports = __webpack_public_path__ + "img/selected5-min.31241a7a.png";